// @flow
import { Selector } from "src/utils/selectorUtils";
import TrendModel from "src/models/TrendModel";

class PatientTrendSelector extends Selector<TrendModel> {}

export default new PatientTrendSelector("patientTrends", new TrendModel());
